import type { ICatalogState } from "../model/catalogTypes"
import type { TEditableFilterPayload } from "../model/filterTypes"

export const findCurrentOption = (state: ICatalogState, payload: TEditableFilterPayload) =>
    state.editableFilter.find((option) => option.title === payload.title)
